import { IBlock } from "../../../framework/src/IBlock";
import { Message } from "../../../framework/src/Message";
import { BlockComponent } from "../../../framework/src/BlockComponent";
import MessageEnum, {
  getName,
} from "../../../framework/src/Messages/MessageEnum";
import { runEngine } from "../../../framework/src/RunEngine";

// Customizable Area Start
import moment from "moment";
import { makeApiMessage } from "../../../components/src/common";
// Customizable Area End

export const configJSON = require("./config");

export interface Props {
  navigation: any;
  id: string;
  // Customizable Area Start
  classes?: any;
  open: any;
  handleClose: any;
  customerData?: any;
  handleIsEdit: any;
  isB2bActive: boolean;
  onRedeemed?: () => void;
  // Customizable Area End
}

interface S {
  txtInputValue: string;
  txtSavedValue: string;
  enableField: boolean;
  // Customizable Area Start
  isLoading: boolean;
  selectedTab: any;
  customerDetails: any;
  isRedeeming: boolean;
  redeemSnackbarOpen: boolean;
  redeemSnackbarSeverity: "success" | "error";
  redeemSnackbarMessage: string;
  refreshedCustomerData: any;
  freeWashData: any;
  showFreeWashModal: boolean;
  // Customizable Area End
}

interface SS {
  id: any;
  // Customizable Area Start
  // Customizable Area End
}

export default class ShowCustomerDetailsModalController extends BlockComponent<
  Props,
  S,
  SS
> {
  // Customizable Area Start
  getCustomerDetailsApiCallId: string = "";
  redeemPointsApiCallId: string = "";
  refreshCustomerApiCallId: string = "";
  customerFreewashApiCallId: string = "";
  authToken: string = "";

  async componentDidMount() {
    const authToken = localStorage.getItem("token");
    if (typeof authToken === "string") {
      this.authToken = authToken;
    }
  }

  componentDidUpdate(prevProps: any) {
    if (this.props.open !== prevProps.open) {
      this.setState({ selectedTab: 0, refreshedCustomerData: null });
    }
  }
  // Customizable Area End

  constructor(props: Props) {
    super(props);
    this.receive = this.receive.bind(this);

    // Customizable Area Start
    this.subScribedMessages = [
      getName(MessageEnum.AccoutLoginSuccess),
      // Customizable Area Start
      getName(MessageEnum.RestAPIResponceMessage),
      getName(MessageEnum.NavigationPayLoadMessage),

      getName(MessageEnum.RestAPIResponceDataMessage),
      getName(MessageEnum.SessionSaveMessage),
      getName(MessageEnum.SessionResponseMessage),
      // Customizable Area End
    ];

    this.state = {
      txtInputValue: "",
      txtSavedValue: "A",
      enableField: false,
      // Customizable Area Start
      isLoading: false,
      selectedTab: 0,
      customerDetails: {},
      isRedeeming: false,
      redeemSnackbarOpen: false,
      redeemSnackbarSeverity: "success",
      redeemSnackbarMessage: "",
      refreshedCustomerData: null,
      freeWashData: {},
      showFreeWashModal: false,
      // Customizable Area End
    };
    runEngine.attachBuildingBlock(this as IBlock, this.subScribedMessages);

    // Customizable Area Start
    // Customizable Area End
  }

  async receive(from: string, message: Message) {
    runEngine.debugLog("Message Recived", message);

    // Customizable Area Start
    if (getName(MessageEnum.RestAPIResponceMessage) === message.id) {
      const apiCallId = message.getData(
        getName(MessageEnum.RestAPIResponceDataMessage)
      );
      const responseJson = message.getData(
        getName(MessageEnum.RestAPIResponceSuccessMessage)
      );

      if (apiCallId === this.redeemPointsApiCallId) {
        this.handleRedeemPointsResponse(responseJson);
      } else if (apiCallId === this.refreshCustomerApiCallId) {
        this.handleRefreshCustomerResponse(responseJson);
      } else if (apiCallId === this.customerFreewashApiCallId) {
        this.handleCustomerFreeWash(responseJson);
      }
    }
    // Customizable Area End
  }

  // Customizable Area Start
  handleTabChange(event: any, value: any) {
    this.setState({ selectedTab: value });
  }

  showExpiryData = (date: string) => {
    return moment(date).format("DD/MM/YYYY");
  };

  handleRedeemPoints = () => {
    if (this.state.isRedeeming) return;
    const customerId = this.props.customerData?.id;
    const points = Number(
      this.props.customerData?.attributes?.total_reward_points
    );
    if (!customerId || !(points > 0)) {
      this.setState({
        redeemSnackbarOpen: true,
        redeemSnackbarSeverity: "error",
        redeemSnackbarMessage: "No loyalty points available to redeem.",
      });
      return;
    }

    this.setState({ isRedeeming: true });

    const requestMessage = makeApiMessage({
      url: `${configJSON.redeemPointsApiEndPoint}?id=${customerId}`,
      method: configJSON.redeemPointsApiMethod,
      body: JSON.stringify({ points }),
    });

    this.redeemPointsApiCallId = requestMessage.messageId;
    runEngine.sendMessage(requestMessage.id, requestMessage);
  };

  handleRedeemPointsResponse = (responseJson: any) => {
    this.setState({ isRedeeming: false });
    if (responseJson?.status === 200) {
      const balance = responseJson.wallet_balance;
      const currency = responseJson.currency || "";
      const redeemed = responseJson.redeemed_amount;
      const parts = [responseJson.message || "Points redeemed."];
      if (redeemed) parts.push(`Redeemed: ${redeemed} ${currency}`.trim());
      if (balance) parts.push(`Wallet: ${balance} ${currency}`.trim());
      this.setState({
        redeemSnackbarOpen: true,
        redeemSnackbarSeverity: "success",
        redeemSnackbarMessage: parts.join(" — "),
      });
      this.refreshCustomerDetails();
      if (typeof this.props.onRedeemed === "function") {
        this.props.onRedeemed();
      }
    } else {
      const errorMsg =
        responseJson?.errors ||
        responseJson?.error ||
        responseJson?.message ||
        "Failed to redeem points.";
      this.setState({
        redeemSnackbarOpen: true,
        redeemSnackbarSeverity: "error",
        redeemSnackbarMessage:
          typeof errorMsg === "string" ? errorMsg : "Failed to redeem points.",
      });
    }
  };

  closeRedeemSnackbar = () => {
    this.setState({ redeemSnackbarOpen: false });
  };

  refreshCustomerDetails = () => {
    const attributes = this.props.customerData?.attributes || {};
    const fullPhone =
      attributes.full_phone_number ||
      `${attributes.country_code || ""}${attributes.phone_number || ""}`;
    if (!fullPhone) return;

    const storeId = localStorage.getItem("store_id") || "";
    const url =
      `${configJSON.searchCustomerAccountApiEndPoint}` +
      `?full_phone_number=${encodeURIComponent(fullPhone)}` +
      `&cart_order_required=false` +
      (storeId ? `&store_id=${encodeURIComponent(storeId)}` : "");

    const requestMessage = makeApiMessage({
      url,
      method: "GET",
    });

    this.refreshCustomerApiCallId = requestMessage.messageId;
    runEngine.sendMessage(requestMessage.id, requestMessage);
  };

  handleRefreshCustomerResponse = (responseJson: any) => {
    if (responseJson?.data) {
      this.setState({ refreshedCustomerData: responseJson.data });
    }
  };

  getDisplayCustomerData = () => {
    return this.state.refreshedCustomerData ?? this.props.customerData;
  };

  customerFreeWashDetails = (customerId: any) => {
    const url = `${configJSON.customerFreeWash}?customer_id=${customerId}`;
    const requestMessage = makeApiMessage({
      url,
      method: "GET",
    });

    this.customerFreewashApiCallId = requestMessage.messageId;
    runEngine.sendMessage(requestMessage.id, requestMessage);
  };

  handleCustomerFreeWash = (responseJson: any) => {
    this.setState({
      freeWashData: responseJson.free_washes || responseJson || [],
      showFreeWashModal: true
    });
  };

  // Customizable Area End
}
